




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProgram, ICourse, SearchType } from '../Scripts/ISearchService';
import ResultPanel from './ResultPanel.vue';
import FavoritesSlider from './FavoritesSlider.vue';
import { PrintContext } from '../Scripts/PrintContext';
import { PrintService } from '../Scripts/PrintService';
import ActionTracker, { PrintEvent } from '../Scripts/AnalyticsEvents';
import { Getters } from '../store';
import { mapGetters } from 'vuex';

// TODO:TRS similar type is defined in FavoritesSlider
type FieldData<T> = {
	name: string;
	field: (p: T) => string;
};

@Component({
	components: {
		ResultPanel, FavoritesSlider
	},
	computed: {
		...mapGetters({
			applicationName: Getters.applicationName
		})
	}
})
export default class PrintPanel extends Vue {
	@Prop() public printContext!: PrintContext;
	@Prop() public defaultStyle!: string;
	@Prop() public searchType!: SearchType;

	private columnCount: number | null = null;
	private labelWidth = 20;
	private currentStyle: string | null = null;
	private includeDesc = true;

	private code = '';
	private baseUrl = '';
	private image = '';

	public async mounted (): Promise<void> {
		const service = new PrintService();

		const short = await service.getShortUrl(this.printContext.path);

		const data = short.data;

		this.code = data.code;
		this.baseUrl = data.redemptionUri;
		this.image = `data:image/png;base64, ${data.qrImage}`;
	}

	get style (): string {
		return this.currentStyle || this.defaultStyle || 'list';
	}

	set style (val: string) {
		this.currentStyle = val;
	}

	get chunky (): (IProgram[] | ICourse[])[] {
		return this.chunk(this.printContext.items, this.currCols);
	}

	get headerWidth (): string {
		return `${this.labelWidth}%`;
	}

	get width (): string {
		return `${(100 - this.labelWidth) / (this.currCols)}%`;
	}

	get currCols (): number {
		if (!this.columnCount) {
			this.columnCount = Math.min(3, this.printContext.items.length);
		}

		return this.columnCount;
	}

	set currCols (value: number) {
		this.columnCount = value;
	}

	get maxCols (): number {
		return Math.min(6, this.printContext.items.length);
	}

	private close (): void {
		this.$emit('close');
	}

	private print (): void {
		ActionTracker.track(new PrintEvent(this.style, this.currCols, this.includeDesc));
		window.print();
	}

	private chunk (arr: IProgram[] | ICourse[], len: number): (IProgram[] | ICourse[]) [] {
		const chunks: (IProgram[] | ICourse[])[] = [];
		const end = arr.length;
		let i = 0;

		while (i < end) {
			chunks.push(arr.slice(i, i += len));
		}

		return chunks;
	}

	// TODO:TRS How does this overlap with FavoritesSlider
	get fields (): FieldData<IProgram>[] | FieldData<ICourse>[] {
		switch (this.searchType) {
			case SearchType.Program: return this.programFields;
			case SearchType.Course: return this.courseFields;
			default: return [];
		}
	}

	get programFields () : FieldData<IProgram>[] {
		const vals = [
			{ name: 'Institution', field: (p: IProgram) => p.institutionName },
			{ name: 'Location', field: (p: IProgram) => `${p.city}, ${p.state}` },
			{ name: 'Program Level', field: (p: IProgram) => p.level },
			{ name: 'Degree Type', field: (p: IProgram) => p.degree },
			{ name: 'Subject', field: (p: IProgram) => p.subject },
			{ name: 'Instructional Language', field: (p: IProgram) => p.language },
			{ name: 'Speed', field: (p: IProgram) => p.deliverySpeed },
			{ name: 'Method', field: (p: IProgram) => p.deliveryMode },
			{ name: 'Presence Requirement', field: (p: IProgram) => p.presence || 'None' },
			{ name: 'Length', field: (p: IProgram) => p.length },
			{ name: 'Average Time', field: (p: IProgram) => p.averageTime },
			{
				name: 'Tutition and Fees',
				field: (p: IProgram) => {
					const instate = p.inState.toLocaleString();
					const outstate = p.outState.toLocaleString();
					return `In-State: $${instate}; Out-of-State: $${outstate}`;
				}
			},
			{ name: 'Other Costs', field: (p: IProgram) => p.costs || 'None' },
			{ name: 'Description', field: (p: IProgram) => p.description }
		];

		return this.includeDesc ? vals : vals.filter((v) => v.name !== 'Description');
	}

	get courseFields (): FieldData<ICourse>[] {
		const vals = [
			{ name: 'Institution', field: (p: ICourse) => p.institutionName },
			{ name: 'Location', field: (p: ICourse) => `${p.city}, ${p.state}` },
			{ name: 'Term', field: (p: ICourse) => { return p.yearTerm + (p.termDisplay ? ` (${p.termDisplay})` : ''); } },
			{ name: 'Course Identifier', field: (p: ICourse) => `${p.courseDepartment} ${p.courseNumber}` },
			{ name: 'Credits', field: (p: ICourse) => `${p.credits.toFixed(2)} (${p.unitForCredits})` },
			{ name: 'Course Level', field: (p: ICourse) => p.courseLevel },
			{ name: 'Subject', field: (p: ICourse) => p.subject },
			{ name: 'Prerequisites', field: (p: ICourse) => p.prerequisites },
			{ name: 'Instructional Language', field: (p: ICourse) => p.language },
			{ name: 'Speed', field: (p: ICourse) => p.deliverySpeed },
			{ name: 'Method', field: (p: ICourse) => p.deliveryMode },
			{ name: 'Presence Requirement', field: (p: ICourse) => p.presence || 'None' },
			{
				name: 'Tutition and Fees',
				field: (p: ICourse) => {
					const instate = p.inState.toLocaleString();
					const outstate = p.outState.toLocaleString();
					return `In-State: $${instate}; Out-of-State: $${outstate}`;
				}
			},
			{ name: 'Other Costs', field: (p: ICourse) => p.costs || 'None' },
			{ name: 'Additional Information', field: (p: ICourse) => p.additionalInformation || 'N/A' },
			{ name: 'Description', field: (p: ICourse) => p.description }
		];

		return this.includeDesc ? vals : vals.filter((v) => v.name !== 'Description');
	}
}
